module.exports = __webpack_public_path__ + "img/color-4.ba118c2.png";